import axios from 'axios';
import {getMeta} from "../helpers/_utilities";
import variables from "../variables";

const api = axios.create({
    baseURL: '/',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': getMeta(variables.metaNames.token)
    }
});

export default api;
